import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css'
import registerServiceWorker from './registerServiceWorker';
import { App } from "./components/App";

ReactDOM.render(
    <App />,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx